import {setupLiveToggle} from './liveToggle'
import debouncedRefresh from './debouncedRefresh'
import managedSubscription from './managedSubscription'

const subscription = managedSubscription()
const refresh = debouncedRefresh(1000)

$(document).on('turbo:load', function() {
  const config = $('#cable')?.data() || {}

  if (config.channel != 'JuryAppClientsChannel') {
    subscription.clear()
    return
  }

  const {channel, eventId, updates} = config

  setupLiveToggle(channel)

  subscription.ensure(config, {channel: channel, eventId: eventId}, {
    received(data) {
      if (updates.includes(data.update)) {
        refresh.next()
      }
    }
  })
})
